export function getProductDeliveryTimes(state) {
    return state.productDeliveryTimes;
}
